<template>
  <div class="animated fadeIn">
    <div class="card">
      <div class="row">
        <div class="col-md-12 col-xs-12 col-sm-12 text-center">
          <h4 class="mt-3"><b>Bill <i class="far fa-ballot-check"></i></b></h4>
          <div class="row mt-2 mr-2 ml-2">
            <div class="col-md-2 col-xs-2 col-sm-2 mb-2">
              <h5><b>ช่วงเวลาวันที่:&nbsp;</b></h5>
            </div>
            <div class="col-md-4 col-xs-4 col-sm-4 mb-2">
              <v-date-picker mode='range' v-model='picker' :input-props='{ class:"pull-right text-center form-control",style:"background: #fff; cursor: pointer; padding: 5px 10px; border: 1px solid #ccc; width: 100%", placeholder: "กรุณาเลือกช่วงเวลาของยอดขายที่ต้องการทราบ", readonly: true }'
              show-caps></v-date-picker>
            </div>
            <div class="col-md-3 col-xs-3 col-sm-3 mb-2">
              <button type="button" class="btn btn-primary form-control" v-on:click="getAPISales()">
                ตรวจสอบ <i class="fas fa-search"></i>
              </button>
            </div>
            <div class="col-md-3 col-xs-3 col-sm-3 mb-2">
              <button type="button" class="btn btn-primary form-control" v-on:click="exportFromExcelSales()">
                ดาวน์โหลด XLSX <i class="far fa-download"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="col-md-12 col-xs-12 col-sm-12">
          <vue-bootstrap4-table :rows="table.sales.rows" :columns="table.sales.columns" @refresh-data="sendAPISales"
          :config="table.sales.config">
          <template slot="manage_sales_code" slot-scope="props">
            <button @click="getAPISalesItem(props.cell_value)" type="button" class="btn btn-primary"><i class="fas fa-ballot"></i>
            เลือก</button>
          </template>
        </vue-bootstrap4-table>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 col-xs-12 col-sm-12 text-center">
        <div class="row mt-2 mr-2 ml-2">
          <div class="col-md-6 col-xs-6 col-sm-6 mb-2">
            <h5><b v-html="data.detail"></b></h5>
          </div>
          <div class="col-md-3 col-xs-3 col-sm-3 mb-2" v-if="data.sales_code!==''">
            <button type="button" class="btn btn-primary form-control" @click="exportFromExcelItem()"><i class="far fa-download"></i>
            ดาวน์โหลด</button>
          </div>
          <div class="col-md-3 col-xs-3 col-sm-3 mb-2" v-if="data.sales_code!==''">
            <button type="button" class="btn btn-danger form-control" @click="show()"><i class="far fa-trash-alt"></i>
            ลบและคืนสินค้า</button>
          </div>
        </div>
      </div>
      <div class="col-md-12 col-xs-12 col-sm-12">
        <vue-bootstrap4-table :rows="table.items.rows" :columns="table.items.columns" @refresh-data="sendAPIItems"
        :config="table.items.config">
        <template slot="manage_sales_code" slot-scope="props">
          <button @click="getAPISalesItem(props.cell_value)" type="button" class="btn btn-primary"><i class="fas fa-ballot"></i>
          เลือก</button>
        </template>
      </vue-bootstrap4-table>
    </div>
  </div>
</div>
<v-dialog/>
<Loading :percent="load.percent" :active="load.active"></Loading>
</div>
</template>
<script>
import Vue from 'vue';
import VCalendar from 'v-calendar';
import 'v-calendar/lib/v-calendar.min.css';
import XLSX from 'xlsx';
import JWT from '../../utils/JWT.js';
import VModal from 'vue-js-modal'
Vue.use(VModal,{dialog:true});
Vue.use(VCalendar);
export default {
  components: {
    'vue-bootstrap4-table': () => import('vue-bootstrap4-table'),
    'Loading': () => import('../../utils/Loading.vue')
  },
  data() {
    return {
      alert: {
        message: ''
      },
      load: {
        task: 0,
        count: 0,
        percent: 0,
        active: false
      },
      data: {
        sales_code: '',
        detail: 'กรุณาเลือกข้อมูลที่ต้องการจัดการ',
        date: {
          start: '',
          end: ''
        }
      },
      picker: {
        start: this.$moment().toDate(),
        end: this.$moment().toDate()
      },
      table: {
        items: {
          rows: [],
          config: {
            per_page: 15,
            per_page_options: [15, 25, 50, 75, 100],
            global_search: {
              placeholder: "ค้นหา...",
            }
          },
          columns: [{
            label: "Invoice Number",
            name: "sales_code",
            sort: true,
          }, {
            label: "Created At",
            name: "created_at",
            sort: true,
            initial_sort: true,
            initial_sort_order: "desc"
          }, {
            label: "SKU Code",
            name: "skus_code",
            sort: true,
          }, {
            label: "SKU Name",
            name: "sku_name",
            sort: true,
          }, {
            label: "Price",
            name: "price",
            sort: true,
          }, {
            label: "PC",
            name: "quantity",
            sort: true,
          }, {
            label: "GSV",
            name: "sales",
            sort: true,
          }]
        },
        sales: {
          rows: [],
          config: {
            per_page: 5,
            per_page_options: [5, 25, 50, 75, 100],
            global_search: {
              placeholder: "ค้นหา...",
            }
          },
          columns: [{
            label: "Invoice Number",
            name: "sales_code",
            sort: true,
          }, {
            label: "Date",
            name: "sales_date",
            sort: true,
          }, {
            label: "Seller Code",
            name: "seller_code",
            sort: true,
          }, {
            label: "Seller Name",
            name: "seller_name",
            sort: true,
          }, {
            label: "Customer Code",
            name: "customer_code",
            sort: true,
          }, {
            label: "Customer Name",
            name: "customer_name",
            sort: true,
          }, {
            label: "Sales",
            name: "sales",
            sort: true,
          }, {
            label: "Created At",
            name: "created_at",
            sort: true,
            initial_sort: true,
            initial_sort_order: "desc"
          }, {
            label: "Manage",
            name: "manage_sales_code",
            sort: true,
          }]
        }
      }
    }
  },
  mounted() {
    this.getAPISales();
  },
  methods: {
    show () {
      this.$modal.show('dialog', {
        title: 'ลบและคืนสินค้า',
        text: '<b>คุณต้องการลบและคืนสินค้าของ</b><br>'+this.data.detail,
        buttons: [{
          title: 'ยืนยันลบและคืนสินค้า',
          handler: () => this.deletSales()
        },{
          title: 'ยกเลิก',
          handler: () => this.hide()
        }]
      })
    },
    hide () {
      this.$modal.hide('dialog');
    },
    resetLoading(task) {
      this.load.count = 0
      this.load.task = task
      this.load.percent = 0
      this.load.active = true
    },
    async sendAPISales() {
      try {
        await this.resetLoading(1)
        this.table.items.rows = []
        this.data.detail = 'กรุณาเลือกข้อมูลที่ต้องการจัดการ'
        this.data.sales_code = ''
        const res = (await this.$http.get(process.env.VUE_APP_AUTH_URL + 'api/v1/admin/cn/bill/sales/' + await JWT.encode({
          start: this.data.date.start,
          end: this.data.date.end
        }))).body
        let value = null,
        data = [],
        customerName = '',
        sellerName = ''
        for (value of res['sales']) {
          sellerName = '-'
          customerName = '-'
          if (res['sellers'][value.seller_code]) {
            sellerName = res['sellers'][value.seller_code]
          }
          if (res['customers'][value.customer_code]) {
            customerName = res['customers'][value.customer_code]
          }
          data.push({
            sales_code: value.sales_code,
            sales_date: value.sales_date,
            seller_code: value.seller_code,
            seller_name: sellerName,
            customer_code: value.customer_code,
            customer_name: customerName,
            sales: value.sales,
            created_at: value.created_at,
            manage_sales_code: value.sales_code
          })
        }
        this.table.sales.rows = data
        this.load.active = false
      } catch (error) {
        this.load.active = false
        if (error.body) {
          if (error.body.alert) {
            this.alert.message = error.body.alert
          } else {
            this.alert.message = 'ไม่สามารถเชื่อมต่อกับระบบได้ กรุณาตรวจสอบเครื่อข่าย'
          }
        } else {
          this.alert.message = 'ไม่สามารถเชื่อมต่อกับระบบได้ กรุณาตรวจสอบเครื่อข่าย'
        }
        this.$dialogs.alert(this.alert.message,{title: 'พบข้อผิดพลานในการส่งข้อมูล'})
      }
    },
    async deletSales() {
      try {
        await this.hide();
        await this.resetLoading(1)
        const res = (await this.$http.delete(process.env.VUE_APP_AUTH_URL + 'api/v1/admin/cn/bill/sales', {
          body: {
            data: await JWT.encode(this.data.sales_code)
          }
        })).body
        let data = [],
        value = null;
        for (value of this.table.sales.rows) {
          if (value.sales_code !== this.data.sales_code) {
            data.push(value)
          }
        }
        this.table.items.rows = []
        this.data.detail = 'กรุณาเลือกข้อมูลที่ต้องการจัดการ'
        this.data.sales_code = ''
        this.table.sales.rows = data
        this.load.active = false
        this.$dialogs.alert('การลบและคืนสินค้าเรียบร้อย',{title: 'การลบและคืนสินค้าเรียบร้อย'})        
      } catch (error) {
        this.load.active = false
        if (error.body) {
          if (error.body.alert) {
            this.alert.message = error.body.alert
          } else {
            this.alert.message = 'ไม่สามารถเชื่อมต่อกับระบบได้ กรุณาตรวจสอบเครื่อข่าย'
          }
        } else {
          this.alert.message = 'ไม่สามารถเชื่อมต่อกับระบบได้ กรุณาตรวจสอบเครื่อข่าย'
        }
        this.$dialogs.alert(this.alert.message,{title: 'พบข้อผิดพลานในการส่งข้อมูล'})
      }
    },
    async sendAPIItems() {
      try {
        await this.resetLoading(1)
        const res = (await this.$http.get(process.env.VUE_APP_AUTH_URL + 'api/v1/admin/cn/bill/items/' + await JWT.encode({
          sales_code: this.data.sales_code,
          start: this.data.date.start,
          end: this.data.date.end
        }))).body
        this.table.items.rows = res
        this.load.active = false
      } catch (error) {
        this.load.active = false
        if (error.body) {
          if (error.body.alert) {
            this.alert.message = error.body.alert
          } else {
            this.alert.message = 'ไม่สามารถเชื่อมต่อกับระบบได้ กรุณาตรวจสอบเครื่อข่าย'
          }
        } else {
          this.alert.message = 'ไม่สามารถเชื่อมต่อกับระบบได้ กรุณาตรวจสอบเครื่อข่าย'
        }
        this.$dialogs.alert(this.alert.message,{title: 'พบข้อผิดพลานในการส่งข้อมูล'})
      }
    },
    getDetailSales() {
      let value = null,
      detail = 'กรุณาเลือกข้อมูลที่ต้องการจัดการ'
      for (value of this.table.sales.rows) {
        if (value.sales_code === this.data.sales_code) {
          detail = 'Bill: ' + value.sales_code + ' | ' + value.seller_code +' : '+value.seller_name+ '<br>' + value.customer_code + ' : ' + value.customer_name
          break
        }
      }
      this.data.detail = detail
    },
    getAPISalesItem(salesCode) {
      this.data.sales_code = salesCode
      this.getDetailSales()
      this.sendAPIItems()
    },
    getAPISales() {
      this.data.date = {
        'start': this.$moment(this.picker.start).format('YYYY-MM-DD'),
        'end': this.$moment(this.picker.end).format('YYYY-MM-DD')
      }
      this.sendAPISales()
    },
    async exportFromExcelItem() {
      let data = [],
      value = null;
      for (value of this.table.items.rows) {
        data.push({
          sales_code: value.sales_code,
          created_at: value.created_at,
          sku_code: value.sku_code,
          sku_name: value.sku_name,
          price: value.price,
          quantity: value.quantity,
          sales: value.sales
        })
      }
      if (data.length > 0) {
        const wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, await XLSX.utils.json_to_sheet(data), 'LMT CN Bill Sales Item')
        XLSX.writeFile(wb, 'lmt_'+this.data.sales_code + '_' + await this.$moment().format('YYYY-MM-DD-H-mm-ss') + '_' + await this.$moment(
          this.picker.start).format('YYYY-MM-DD') + '_' + await this.$moment(
          this.picker
          .end).format(
          'YYYY-MM-DD') + '.xlsx')
      }
    },
    async exportFromExcelSales() {
      let data = [],
      value = null;
      for (value of this.table.sales.rows) {
        data.push({
          sales_code: value.sales_code,
          sales_date: value.sales_date,
          seller_code: value.seller_code,
          seller_name: value.seller_name,
          customer_code: value.customer_code,
          customer_name: value.customer_name,
          sales: value.sales,
          created_at: value.created_at
        })
      }
      if (data.length > 0) {
        const wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, await XLSX.utils.json_to_sheet(data), 'LMT CN Bill Sales')
        XLSX.writeFile(wb, 'lmt_cn_bill_sales_' + await this.$moment().format('YYYY-MM-DD-H-mm-ss') + '_' + await this.$moment(this
          .picker.start).format('YYYY-MM-DD') + '_' + await this.$moment(
          this.picker
          .end).format(
          'YYYY-MM-DD') + '.xlsx')
      }
    }
  }
}

</script>
